"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiTaxes {
    static getW2Election(token) {
        let url = "/taxes/getW2Election";
        return Client_1.default.httpGet(url, token);
    }
    static updateW2Election(token, isElectronic) {
        let url = "/taxes/updateW2Election";
        return Client_1.default.httpPost(url, token, { isElectronic });
    }
    static get1095CElection(token) {
        let url = "/taxes/get1095CElection";
        return Client_1.default.httpGet(url, token);
    }
    static update1095CElection(token, isElectronic) {
        let url = "/taxes/update1095CElection";
        return Client_1.default.httpPost(url, token, { isElectronic });
    }
    static getTaxesSummary(token) {
        let url = "/taxes/summary";
        return Client_1.default.httpGet(url, token);
    }
    static updateFederalW4(token, body) {
        let url = "/taxes/updateFederalW4";
        return Client_1.default.httpPost(url, token, body);
    }
    static updateStateW4(token, body) {
        let url = "/taxes/updateStateW4";
        return Client_1.default.httpPost(url, token, body);
    }
    static getDocuments(token) {
        let url = "/taxes/documents";
        return Client_1.default.httpGet(url, token);
    }
    static getW2Download(token, year) {
        let url = `/taxes/w2/download?year=${year}`;
        return Client_1.default.httpGet(url, token);
    }
    static getW2CDownload(token, year) {
        let url = `/taxes/w2c/download?year=${year}`;
        return Client_1.default.httpGet(url, token);
    }
    static get1095cDownload(token, year) {
        let url = `/taxes/1095c/download?year=${year}`;
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiTaxes;
